import PageTitle from "../../../components/PageTitle";
import CardCount from "../../../components/CardCount";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { Grid } from "@mui/material";
import { Group as StudentIcon, Class as ClassIcon } from "@mui/icons-material";
import NoRecentUsers from "../../../assets/images/nofeatureicons/norecentuser.svg";
import Table from "../../../components/Table/Table";
import useStyles from "../styles";
import { TableSearch } from "../../../components/Table/TableActions";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";

const HOSTEL_EDIT_ENDPOINT = "/api/v1/hostel-management/my-hostel";
const HOSTEL_MEMBER_ENDPOINT = "/api/v1/hostel-management/hostel-rooms/my-room";

const StudentHostel = () => {
  const classes = useStyles();
  const [isRoomGetting, setIsRoomGetting] = useState(false);
  const navigate = useNavigate();
  const [hostels, setHostels] = useState([]);
  const [hostelMembers, setHostelMembers] = useState([]);
  const [roomModal, setRoomModal] = useState(false);
  const [isMembersGetting, setIsMembersGetting] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const width = useWindowSize();
  const mobile = width < 600;

  const actions = [
    { label: "Messages", icon: "mdi:message-text-outline" }
  ];

  const handleCreateRoomModal = () => {
    setRoomModal(!roomModal);
  };

  const recentUser = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {row?.full_name || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.class || "--/--"}
        </>
      )
    },
    {
      name: "Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "Date Added",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Added</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    }
  ];

  /**
     * Fetches Hostel by ID
     */
  const getAllHostelMembers = () => {
    setIsMembersGetting(true);
    httprequest.get(`${HOSTEL_MEMBER_ENDPOINT}`).then((res) => {
      setHostelMembers(res?.data?.data?.hostel_members);
      setSearchResult(res?.data?.data?.hostel_members);
      setIsMembersGetting(false);
    }).catch((err) => {
      setIsMembersGetting(false);
      toast.error(err?.response?.data);
    });
  };

  /**
     * Fetches Hostel by ID
     */
  const getAllHostelbyID = () => {
    setIsRoomGetting(true);
    httprequest.get(`${HOSTEL_EDIT_ENDPOINT}`).then((res) => {
      setHostels(res?.data?.data);
      setIsRoomGetting(false);
    }).catch((err) => {
      setIsRoomGetting(false);
      toast.error(err?.response?.data);
    });
  };

  const handleClick = (label) => {
    if (label === "Create Room") {
      handleCreateRoomModal();
    } else if (label === "Messages") {
      navigate("/hostel/my-messages");
    }
  };

  useEffect(() => {
    getAllHostelbyID();
    getAllHostelMembers();
  }, []);

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = hostelMembers?.filter((data) => valArray?.every(
      (word) => data?.full_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <>
      <PageTitle
        title="My Hostel"
        subtitle="My hostel details, room, and room mates."
      />
      <div className="page-content margin-top-16">
        <div className={classes.flexx}>
          <div className={classes.hosteldetail}>
            <h2>{hostels?.hostel?.name || "Hostel Name"}</h2>
            <p>{hostels?.hostel?.gender} Hostel | {hostels?.hostel?.number_of_bedspace}-Man Room</p>
            <p>Hostel Master Name:  <strong>{hostels?.hostel?.hostel_master?.name || "--/--"}</strong></p>
            <p>Hostel Email: <strong>{hostels?.hostel?.hostel_master?.email || "--/--"}</strong></p>
          </div>
          <div className={classes.container}>
            {actions?.map(({ label, icon }) => (
              <div onClick={() => handleClick(label)} key={label} className={classes.item}>
                <div className={classes.iconWrapper}>
                  <Icon icon={icon} className={classes.iconStyle} />
                </div>
                <span className={classes.label}>{label}</span>
              </div>
            ))}
          </div>
        </div>
        {isRoomGetting ? (
          <PageLoader />
        ) : (
          <>
            <Grid container spacing={4}>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <CardCount
                  title="Number of Roommates"
                  count={hostels?.hostel?.number_of_students || 0}
                  icon={<StudentIcon />}
                />
              </Grid>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <CardCount
                  title="Allocated Spaces"
                  count={hostels?.allocated_rooms?.[0]?.allocated_count || 0}
                  icon={<Icon icon="mdi:guest-room-outline" />}
                />
              </Grid>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <CardCount
                  title="Unallocated Spaces"
                  count={hostels?.allocated_rooms?.[0]?.unallocated_bedspace || 0}
                  icon={<ClassIcon />}
                />
              </Grid>
            </Grid>
            <div className="margin-top-16">
              {isMembersGetting ? (
                <PageLoader />
              ) : (
                hostelMembers?.length > 0 ? (
                  <Table data={searchResult} columns={recentUser} subHeader={true} pagination subHeaderComponent={
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInventory} />
                  }
                  />
                ) : (
                  <div className={classes.notfound}>
                    <NoData
                      img={NoRecentUsers}
                      title="No Room member has been addedd"
                      subtitle="No room member has been created or added to your room"
                    />
                  </div>
                )
              )}
            </div>
          </>
        )}
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default StudentHostel;
